import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
// if you've gone with the local installation approach, you'd use the following:
import * as firebase from 'firebase';

enum VotingStage {
    Closed = 1,
    Open,
    Finished
}

enum StageDirection {
    Forward = 1,
    Backward
}

// Static Data
  
// TAB1 (Shared) mystery - mysteryDetails
// Myster Intro
// Character list
// BG Info
// Investigation

// TAB2 
// Static (Personal)  characterDetails
// Character Details
// Objectives
// Monologues

// Changing (personal)  parties - partyGuests
// money amount

@Injectable()
export class DataService {

  public votingStageEnum = VotingStage
  public stageDirectionEnum = StageDirection

	public isHost: Boolean = false;
	public hostStageInfo: String = "hello";
	public stageTitle: String = "";
	public playerStageInfo: String = "";
	public nextStageTitle: String = "";
	public nextStageInfo: String = "";

	public mysteryInformation: Array<any> = [];
	public currentMysteryInformation: Array<any> = [];

  public investigationDetails: Array<any> = [];
  public currentInvestigationDetails: Array<any> = [];

	public characterInformation: Array<any> = [];
	public currentCharacterInformation: Array<any> = [];
	
  public feedbackOpen: Boolean = false;

	public walletOpen: Boolean = false;
	public availableFunds: number = -100;
	
	public votingStage: VotingStage = VotingStage.Closed;
	public bestDressedWinners: Array<any> = [];
	public bestPerformanceWinners: Array<any> = [];
	public murdererWinners: Array<any> = [];
	public mostProfitableWinners: Array<any> = [];

	public partyGuests: Array<any> = [];
	public allCharacters: any = {};

  public characterBadge: string = "";
  public investigationBadge: string = "";
  public resultsBadge: string = "";
  public backgroundBadge: string = "";
    
  private charactersDB: any;
	private mysteryDB: any;
	private partyDB: any;
	private characterDetailsDB: any;

  private mysteryId: any;
  private partykey: any;
  private playerKey: string;

  // Party
	private currentStage = -100;
	private bestDressedVotes: Array<any> = [];
	private bestPerformanceVotes: Array<any> = [];
	private murdererGuesses: Array<any> = [];

	// Character
	private murdererKey = undefined;

	// Mystery
	private mystery = undefined;

  public isExample = false;

	// Usefull Getter
  myPartyGuest(){
    return this.partyGuests[this.playerKey];
  }

  constructor() {
  	this.mysteryId = this.getURLParameter("mid");
  	this.partykey = this.getURLParameter("pk");
  	this.playerKey = this.getURLParameter("mid") + this.getURLParameter("pid");
    var example = this.getURLParameter("example");
  	if (this.mysteryId != null && 
  		this.partykey != null && 
  		this.playerKey != null){

  		this.charactersDB = firebase.database().ref('/characters/' + this.mysteryId + '/');
      this.mysteryDB = firebase.database().ref('/mysteries/' + this.mysteryId + '/');
      this.partyDB = firebase.database().ref('/parties/' + this.partykey + '/' + this.mysteryId + '/');
      this.characterDetailsDB = firebase.database().ref('/characterDetails/' + this.mysteryId + '/' + this.playerKey + '/');

      // We should have valid ids so lets get the data
	    this.listenToPartyChanges();
	    // Get the Mystery from firebase
	    this.getMystery();
	    // Get the list of characters for the mystery from firebase
	    this.getCharacterList();
	    // Get my character details from firebase
	    this.getCharacterDetails();
  	}else if(example != null){
      this.isExample = true;
      this.isHost = true;
      this.availableFunds = 500;
      this.investigationBadge = "1";
      this.characterBadge = "1";
      this.resultsBadge = "1";
      this.backgroundBadge = "1";

    }else{
      //TODO: show bad url message
    }
  }

  //////////////////// LOAD THE MODEL FROM FIREBASE ////////////////////

  private listenToPartyChanges(){
    var self = this;
    this.partyDB.on("value", (snapshot) => {
      var partyObj = snapshot.val();
      var stageChanged = false;

      // First lets load all given data
      // always load this data as it is posible it could change
      this.partyGuests = snapshot.child("partyGuests").val();
      if (this.currentStage < 0){
        this.isHost = (this.playerKey == partyObj.host);
        this.currentStage = partyObj.stage;
      }else if(this.currentStage != partyObj.stage){
        stageChanged = true;
      }

      // load votes when they come in
      if ('bestDressedVotes' in partyObj &&
        'bestPerformanceVotes' in partyObj &&
        'murdererGuesses' in partyObj) {
        this.bestDressedVotes = partyObj.bestDressedVotes;
        this.bestPerformanceVotes = partyObj.bestPerformanceVotes;
        this.murdererGuesses = partyObj.murdererGuesses;
        this.loadPlayerVotes();
      }

      // show new data if stage changed
      if(stageChanged){
        this.currentStage = partyObj.stage;
        // show new stage instructions
        // update what mystery nav shows for this stage
        this.updateMysteryDetailsForStage();
        // update what character nav shows for this stage
        this.updateCharacterDetailsForStage();
      }

      // update your money
      if (this.availableFunds != this.myPartyGuest().money) {
        this.availableFunds = this.myPartyGuest().money;
      }
    });
  }
    // ONE time firebase calls
  private getMystery(){
    this.mysteryDB.once("value", (snapshot) => {
      this.mystery = snapshot.val();
      this.mysteryInformation = this.mystery.mysteryDetails;
      this.investigationDetails = this.mystery.investigationDetails;
      this.updateMysteryDetailsForStage();
    });
  }

  private getCharacterList(){
    this.charactersDB.once("value", (snapshot) => {
      this.allCharacters = snapshot.val();
      // find the murderer
      for (var key in this.allCharacters) {
        var character = this.allCharacters[key];
		    if (character.murderer) {
          this.murdererKey = key;
        }
			}
      // call methods waiting on allCharacters
      this.loadPlayerVotes();
    });
  }

  private getCharacterDetails(){
    this.characterDetailsDB.once("value", (snapshot) => {
      this.characterInformation = snapshot.val();
      this.updateCharacterDetailsForStage();
    });
  }

  //////////////////// Methods to update firebase data ////////////////////

  public transferFunds(amount, toKey, callback){
    var amountInt = parseInt(amount); 
    var fromGuest = this.partyGuests[this.playerKey];
    var toGuest = this.partyGuests[toKey];

    var fromMoney = fromGuest.money - amountInt;
    var toMoney = toGuest.money + amountInt;

    var payload = {};
    payload[this.playerKey+"/money"] = fromMoney;
    payload[toKey+"/money"] = toMoney;

    this.partyDB.child("partyGuests").update(payload, callback);
  }

  public castVotes(bestDressedKey, bestPerformerKey, murdererGuessKey, callback){
    let voterKey = this.playerKey;
    var payload = {};
    payload["/bestDressedVotes/"+voterKey] = bestDressedKey;
    payload["/bestPerformanceVotes/"+voterKey] = bestPerformerKey;
    payload["/murdererGuesses/"+voterKey] = murdererGuessKey;

    this.partyDB.update(payload, callback);
  }

  public moveStage(direction: StageDirection){
    var updatedStage = this.currentStage;
    var message = undefined;
    if (direction == StageDirection.Backward) {
      if (this.currentStage > 0) {
        updatedStage = this.currentStage - 1;
      }else{
        message = "You are already at the first stage.";
      }
    }else{
      if (this.currentStage < this.mystery.stageCount - 1) {
        updatedStage = this.currentStage + 1;
      }else{
        message = "You are already on the final stage.";
      }
    }
    if (updatedStage != this.currentStage) {
      this.partyDB.child('stage').set(updatedStage);
    }else{
      console.log(message);
    }
  }

  //////////////////// Refresh the UI with the Model Data ////////////////////

  // called every time the stage changes

  private updateMysteryDetailsForStage(){
    if (this.mystery == undefined) {
      return;
    }
    this.currentMysteryInformation.length = 0;
    this.votingStage = VotingStage.Closed;
    this.resultsBadge = "";
    this.walletOpen = false;
    this.feedbackOpen = false;
    for(var mysteryDetail of this.mysteryInformation){
    	if(mysteryDetail.stages[this.currentStage] == true && 
        mysteryDetail.title != "Voting" &&
        mysteryDetail.title != "Wallet" &&
        mysteryDetail.title != "Results" &&
        mysteryDetail.title != "Feedback") {
    		this.currentMysteryInformation.push(mysteryDetail);
    	}
      if(mysteryDetail.stages[this.currentStage] == true && 
        mysteryDetail.title == "Voting"){
        this.votingStage = VotingStage.Open;
        this.resultsBadge = "1";
      }else if(mysteryDetail.stages[this.currentStage] == true && 
        mysteryDetail.title == "Results"){
        this.votingStage = VotingStage.Finished;
        this.resultsBadge = "1";
      }else if(mysteryDetail.stages[this.currentStage] == true && 
        mysteryDetail.title == "Feedback"){
        this.feedbackOpen = true;
      }
      if(mysteryDetail.stages[this.currentStage] == true && 
        mysteryDetail.title == "Wallet"){
        this.walletOpen = true;
      }
    } 
    var badgeCount = 0;
    this.currentInvestigationDetails.length = 0;
    for(var investigationDetail of this.investigationDetails){
      if(investigationDetail.stages[this.currentStage] == true) {
        this.currentInvestigationDetails.push(investigationDetail);
      }
      var lastStage = this.currentStage - 1;
      if (lastStage >= 0) {
        if(investigationDetail.stages[this.currentStage] == true && 
          investigationDetail.stages[lastStage] == false){
          badgeCount = badgeCount + 1;
        }
      }else if (investigationDetail.stages[this.currentStage] == true){
        badgeCount = badgeCount + 1;
      }
    }
    this.investigationBadge = badgeCount == 0 ? "" : badgeCount.toString();

    var stageInfo = this.mystery.stageInfo[this.currentStage];
    this.stageTitle = stageInfo.stageName; 
    this.playerStageInfo = stageInfo.groupInstruction;
    this.hostStageInfo = stageInfo.hostInstruction;
    var nextStageInfo = this.mystery.stageInfo[this.currentStage + 1];
    if (nextStageInfo == undefined || nextStageInfo == null){
      this.nextStageTitle = null; 
      this.nextStageInfo = null;
    }else{
      this.nextStageTitle = nextStageInfo.stageName; 
      this.nextStageInfo = nextStageInfo.hostInstruction;
    }
  }

  private updateCharacterDetailsForStage(){
    if (this.characterInformation == undefined) {
      return;
    }
    this.currentCharacterInformation.length = 0;
    var badgeCount = 0;
    for (var characterDetail of this.characterInformation){
    	if(characterDetail.stages[this.currentStage] == true){
    		this.currentCharacterInformation.push(characterDetail);
    	}
      var lastStage = this.currentStage - 1;
      if (lastStage >= 0) {
        if(characterDetail.stages[this.currentStage] == true && 
          characterDetail.stages[lastStage] == false){
          badgeCount = badgeCount + 1;
        }
      }else if (characterDetail.stages[this.currentStage] == true){
        badgeCount = badgeCount + 1;
      }
    }
    this.characterBadge = badgeCount == 0 ? "" : badgeCount.toString();
  }

  private loadPlayerVotes(){
    if (Object.keys(this.allCharacters).length == 0){
      return;
    }
    this.bestPerformanceWinners = this.findWinnerByVotes(this.bestPerformanceVotes);
    this.bestDressedWinners = this.findWinnerByVotes(this.bestDressedVotes);
    this.mostProfitableWinners = this.findMostProfitable();

    this.murdererWinners.length = 0;
    var index = 0;
    for (var guesserKey in this.murdererGuesses){
      var guessKey = this.murdererGuesses[guesserKey];
      var guesserName = this.allCharacters[guesserKey].name;
      var guessName = this.allCharacters[guessKey].name;
  		if(guessKey == this.murdererKey){
  			this.murdererWinners.push({ "name" : guesserName, "guess" : guessName, "correct" : true });
  		}else{
				this.murdererWinners.push({ "name" : guesserName, "guess" : guessName, "correct" : false });
  		}
    }
  }

  // sort through model data
  private findWinnerByVotes(votes){
    var voteDict = {};
    var voteWinners = [];
    var max = 0;
    for(var voterKey in votes){
      var voteKey = votes[voterKey];
      if (voteKey in voteDict) {
        voteDict[voteKey] = voteDict[voteKey] + 1;
      }else{
        voteDict[voteKey] = 1;
      }
      if (voteDict[voteKey] > max){
        max = voteDict[voteKey];
      }
    }
    for (var key in voteDict) {
      var count = voteDict[key];
      if (count == max) {
        var name = this.allCharacters[key].name;
        voteWinners.push(name);
      }
    }
    return voteWinners;
  }

  private findMostProfitable(){
    var mostProfitableDict = {};
    var mostProfitable = [];
    var max = 0;

    for (var partyGuestKey in this.partyGuests){
      var partyGuest = this.partyGuests[partyGuestKey];
      var startMoney = this.allCharacters[partyGuestKey].startingMoney;
      var profit = partyGuest.money - startMoney;
      if (profit > max) {
        max = profit;
      }
      mostProfitableDict[partyGuestKey] = profit;
    }
    for (var key in mostProfitableDict) {
      var value = mostProfitableDict[key];
      if (value == max) {
        var name = this.allCharacters[key].name
        mostProfitable.push({ "name" : name, "value" : value });
      }
    }
    return mostProfitable;
  }

	private getURLParameter(name) {
	  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
	}

}

